import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query'
import { TagsQueryKeys } from '../../constants'
import { PlayerTagResponse } from '../../types'
import { getPlayerTagById } from '../services'

export default function useQueryGetPlayerTagById(
	id: string | null,
	props?: UseBaseQueryOptions<PlayerTagResponse>,
) {
	return useQuery({
		queryKey: [TagsQueryKeys.GetTagById, id],
		queryFn: () => getPlayerTagById(id!),
		enabled: !!id,
		...props,
	})
}
